import {
    IStackStyles,
    Stack
} from "@fluentui/react";
import { CustomFontText } from "components/customFontText/CustomFontText";
import React from "react";
import { Col, Row } from "react-grid-system";
import {
    useSelector
} from "react-redux";
import { AppState } from "store/index";
import { isKarlProfile } from "utils/permissions/permissionsHelpers";


const container: IStackStyles = {
    root: {
        marginTop: 10,
        minHeight: 500
    },
};

export const CarlReport = () => {

    const user = useSelector((state: AppState) => state.userProfile.userProfile) as any;
    const isKarlProfileType = user.profileType && isKarlProfile(user.profileType);
    
    return (

        isKarlProfileType ? <>
            <div className="reportFinanceProductWidth">
                <Stack styles={container} tokens={{ childrenGap: 10 }}>
                    <Stack
                        horizontal
                        verticalAlign="center"
                        horizontalAlign="space-between"
                        className="loc_btn_par_con"
                    >
                        <Row>
                            <Col className="alignHeaders">
                                <CustomFontText className="pageTitleFont pageName pageHeaderFont">Carl Report</CustomFontText>
                            </Col>
                        </Row>
                    </Stack>
                    <div className="deskReport reportHeaderPart tablePadSizeWidth datatable-filter-demo trade-in-workboook dropDownBorderColor">
                        <iframe title="Carl Report" style={{ width: '100%', height: "67vh" }} src="https://fiqore.clicdata.com/v/carl_report"></iframe>
                    </div>
                </Stack>
            </div>
        </> : null
    );
};


